module.exports = __webpack_public_path__ + "img/img_3@2x.3ce0d778.png";